import { render, staticRenderFns } from "./XuStoreInfo.vue?vue&type=template&id=14f2b005&scoped=true"
import script from "./XuStoreInfo.vue?vue&type=script&lang=js"
export * from "./XuStoreInfo.vue?vue&type=script&lang=js"
import style0 from "./XuStoreInfo.vue?vue&type=style&index=0&id=14f2b005&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f2b005",
  null
  
)

export default component.exports